import { AutoComplete, ISelectType, useFetch } from "@4uhub/lib4uhub";
import { Grid } from "@mui/material";
import { useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { automationReceivedRuleList } from "../../../../../../../services/ticketAutomationReceivedRule.service";

const translationPath =
  "chatBot.page.automations.automationReceivedRules.ticketAutomationReceivedRuleAllowedAction.";

export const FeaturedReceivedRule = () => {
  const { t } = useTranslation();

  const { sendRequest } = useFetch(automationReceivedRuleList);

  const [optionsFeaturedReceivedRule, setFeaturedReceivedRule] = useState<
    ISelectType[]
  >([]);

  const fetchFeaturedReceivedRule = useCallback(async () => {
    const { data, success } = await sendRequest({ ticketAutomationCode: 26 });
    if (data && success) {
      setFeaturedReceivedRule(
        data.map((d) => ({
          id: d.id,
          name: d.name,
        })),
      );
    }
  }, [sendRequest]);

  useEffect(() => {
    fetchFeaturedReceivedRule();
  }, [fetchFeaturedReceivedRule]);

  return (
    <Grid item xs={12} sm={6}>
      <AutoComplete
        fullWidth
        options={optionsFeaturedReceivedRule}
        name="featuredTicketAutomationReceivedRule"
        label={t(translationPath + "featured_received_rule")}
        getOptionLabel={(option) => option.name}
        size="small"
      />
    </Grid>
  );
};
